
<div class="smart-links-container" *appFeatureToggle="'smartLinksEnabled'">
    <!-- header and sub header-->
    <div class="row justify-content-between no-gutters">
        <div>
            <h2 i18n="smart links header@@smart-links-header" class="widget-header h4">Smart links</h2>
            <h3 class="text-muted h6" i18n="smart links sub header@@smart-links-sub-header">Here you'll find temporary links that will help you during the day. Check back later for more links!</h3>
        </div>
    </div>

    <!-- app tile list-->
    <div class="row">
        <ng-container *ngIf="appTiles$ | async as appTiles">
            <div class="col-12 col-md-6 col-lg-4 col-xxl-3 mt-4" *ngFor="let appTile of appTiles">
                <div class="row">
                    <app-app-tile-box class="col-4" [appTile]="appTile" [hideTitle]="true"></app-app-tile-box>
                    <div class="col-8">

                        <!-- title -->
                        <h3 class="h55 mb-2">

                            <!-- "new"-label for smart link -->
                            <ng-container *appFeatureToggle="'showNewOrModifiedbadgeOnAppTile'">
                                <span class="badge accent-2-bg-color text-uppercase rounded-0 mr-1" *ngIf="shouldDisplayNew(appTile)" i18n="app tile box new@@app-tile-box-new">New</span>
                            </ng-container>

                            <!-- title with link -->
                            <a class="link-text-color" [attr.href]="editMode ? null : getUrl(appTile.Url)" target="_blank">
                                {{appTile.Title}} <span class="font-weight-normal" *ngIf="editMode">{{getAppLanguages(appTile.LanguageTermAppTiles)}}</span>
                            </a>

                            <!-- context menu dots, allows editing/removing -->
                            <div class="more pr-2 pt-1 clickable float-right" *ngIf="editMode" [matMenuTriggerFor]="menu" [matMenuTriggerData]="{data: {appTile:appTile}}">
                                <i class="ms-Icon ms-Icon--MoreVertical" aria-hidden="true"></i>
                            </div>

                            <!--app info -->
                            <span *ngIf="appTile.Introduction || appTile.IntroductionVideo" class="info-section pr-1 clickable" (keyup.enter)="showNewAppInfo($event, appTile)" (click)="showNewAppInfo($event, appTile)" [style.color]="appTile.ColorHexCode ? getColor(appTile.ColorHexCode) : null">
                                <i class="fa fa-info ml-2"></i>
                            </span>
                        </h3>

                        <p class="text-muted app-description" title="{{appTile.Description}}">{{appTile.Description}}</p>
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- extra tile for adding new smart links (edit mode only) -->
        <div class="col-12 col-md-6 col-lg-4 col-xxl-3 mt-4" *ngIf="editMode">
            <div class="media">
                <a class="shadow-none add-smartlink-square mr-3" mat-fab color="primary" [routerLink]="['',{ outlets: { modal: ['app-tiles','add'] } }]" [queryParams]="{IsSmartLink: 'true'}" i18n-title="smart links add title@@smart-links-add-title" title="Add new smart link">
                    <i class="ms-Icon ms-Icon--Add display-4" aria-hidden="true"></i>
                </a>
                <div class="media-body">
                    <h3 class="h55 mb-2" i18n="smart links add title@@smart-links-add-title">Add new smart link</h3>
                    <p class="text-muted" i18n="smart links add description@@smart-links-add-description">Add a new smart link with scheduling.</p>
                </div>
            </div>
        </div>


    </div>
</div>


<!-- menu to edit/remove smart links -->
<mat-menu #menu="matMenu" [xPosition]="'before'" [overlapTrigger]="'false'">
    <ng-template matMenuContent let-data="data">
        <a mat-menu-item [routerLink]="['',{ outlets: { modal: ['app-tiles','edit',data.appTile.Id] } }]" [queryParams]="{IsSmartLink: 'true'}" i18n="edit link apps and tools boxes@@edit-apps-and-tools-boxes">Edit</a>
        <button mat-menu-item (click)="remove(data.appTile)" i18n="delete link apps and tools boxes@@delete-apps-and-tools-boxes">Delete</button>
    </ng-template>
</mat-menu>

<!-- loading spinner -->
<ng-template #loading>
    <div>
        <app-widget-placeholder></app-widget-placeholder>
    </div>
</ng-template>
